import { type ElementType } from 'react'
import {
  Badge,
  BanIcon,
  BoxCheckIcon,
  CircleCheckIcon,
  TriangleExclamationIcon,
  TruckFastIcon,
  TruckIcon,
} from '@quickmd-llc/design-system'
import { OutShipmentStatus } from 'api/generated/pwrdbyQuickMDProvidersApi.schemas'
import { SHIPMENT_STATUS_META } from '../constants'

const STATUS_ICON: Record<OutShipmentStatus, ElementType> = {
  [OutShipmentStatus.preparing]: BoxCheckIcon,
  [OutShipmentStatus.shipped]: TruckIcon,
  [OutShipmentStatus.outfordelivery]: TruckFastIcon,
  [OutShipmentStatus.delivered]: CircleCheckIcon,
  [OutShipmentStatus.exceptionreported]: TriangleExclamationIcon,
  [OutShipmentStatus.voided]: BanIcon,
}

type Props = {
  status: OutShipmentStatus | null
}

// Renders the short status category (Preparing / Shipped / …). The API's longer
// ShipmentStatusDescription is intentionally NOT shown here — it can be a full
// sentence (e.g. an exception reason) that would blow out the table cell; it lives
// in the expanded row instead.
export function StatusBadge({ status }: Props) {
  if (!status) return <span className='text-text-light'>—</span>

  const meta = SHIPMENT_STATUS_META[status]
  const Icon = STATUS_ICON[status]

  return (
    <Badge variant={meta.variant} size='s' icon={<Icon iconSize='s' />}>
      {meta.label}
    </Badge>
  )
}
